import React, {useState, useEffect, useContext, useCallback} from 'react';
import {useParams} from "react-router";
import {APIGetMyMaps} from "../../api/maps/Maps";
import CardGrid from "../../components/cardview/cardGrid";
import {LoadingIndicator} from '../../components/loadingIndicator/loadingIndicator';
import NotFoundMap from "../../assets/map.jpg";
import {ListContext} from "../../context/ListContext";
import {UserContext} from '../../context/UserContext';
import {verifyPermissions} from "../../helper/getProductSettingsHandler";

export const HFProjectsDrafts = ({data}) => {
	const {user,company} = useContext(UserContext);
	const {type} = useParams();
	const [list, setList] = useState(null);


	const settings = {
		all: {
			type:"projects",
			title:"Projeke",
			limit:verifyPermissions(company, "projectsMax"),
			creationAllowed:verifyPermissions(company, "projectsCreation"),
			creationLabel:"Neue Karte erstellen",
			creationType:"map",
			createDialog:{
				image:NotFoundMap,
				text: "Es wurde noch kein Projekt erstellt."
			},
			deleteDialog:{
				headline:"Projekt löschen",
				text: "Mit Löschung wird das Projekt gelöscht und ist somit auch nicht mehr Aufrufbar. Bitte prüfen Sie vor der Löschung, ob das Projekt noch benötigt wird.",
				button: "Endgültig löschen"
			},
			search:{
				searchAllows:verifyPermissions(company, "mapsSearch"),
				text:"Projektname",
			},
			actions:{
				projectCreation:false,
			},
			tableColumns: {
				createdAt:"Erstellt am",
				name:"Name",
			}
		}
	}

	const fetchListData = useCallback(async () => {
		const maps = await APIGetMyMaps(user?.companyId);
		setList(maps);
	}, [user?.companyId]);

	useEffect(() => {

		if (user === undefined) { return; }
	  
		fetchListData();

	}, [fetchListData, user]);


	const currentSetting = settings?.[(typeof type !== "undefined")? type : "all"];
	const currentUpload =   null;


	return list === null ? (
        <div className='flex w-full h-dvh justify-center items-center'>
            <LoadingIndicator/>
        </div>
    ) : (
		<div className={"mx-auto max-w-7xl orderDetails"}>
			<main>
				<div className="w-full flex">
					<ListContext.Provider value={{list, setList, type, currentSetting, currentUpload, fetchListData}}>
						<CardGrid/>
					</ListContext.Provider>
				</div>
			</main>
		</div>
	)

}
